import React from 'react';
import View from './views';
import { LABEL } from '../../veriables';
import PropTypes from 'prop-types';


const Fireboard = (props) => {
    const { setSelectedCheck, selectedCheck } = props;
    const currenySymbol = LABEL().CURRENCY_SYMBOL;

    const viewProps = {
        ...props,
        currency: currenySymbol,
        baseUrl: window.location.origin || '',
        setSelectedCheck: setSelectedCheck,
        selectedCheck,
    };

    return (
        <View
            {...viewProps}
        />
    );
};

Fireboard.propTypes = {
  selectedCheck: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedCheck: PropTypes.func,
};
export default Fireboard;
